import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { webApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';
import { ChangeCampaignStatusComponent } from '../change-campaign-status/change-campaign-status.component';

@Component({
  selector: 'app-list-campaign',
  templateUrl: './list-campaign.component.html',
  styleUrls: ['./list-campaign.component.scss']
})
export class ListCampaignComponent implements OnInit {

  _opened: boolean = false;

  listOfCampaign: any = [];
  listOfCampaignToDisplay: any = [];

  isLoading: boolean = true;
  p: any = 1;
  count: any = 20;

  userDetail: any;
  constructor(public routes: ActivatedRoute,
    private router: Router, private matDialog: MatDialog, private toastr: ToastrService,
    public appService: AppService) {
    this.userDetail = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);
  }

  ngOnInit(): void {
    this.fetchAllCampaign();
    // this.isLoading = false;
  }
  async fetchAllCampaign() {
    this.isLoading = true;

    let param = {};
    try {
      let URL = `${webApi.domain + webApi.endPoint.fetchCampaign}`;
      const httpHeaders = new HttpHeaders({
        Authorization: `Bearer ${this.userDetail['accessToken']}`,
      });
      await this.appService.postMethodWithToken(param, URL, httpHeaders).then((data: any) => {
        if (data['success']) {
          this.listOfCampaign = data['result'];
          this.listOfCampaignToDisplay = this.listOfCampaign;
          this.isLoading = false;
        } else {
          this.listOfCampaign = [];
          this.listOfCampaignToDisplay = this.listOfCampaign;
        } this.isLoading = false;

      });
    } catch (error) {
      this.listOfCampaign = [];
      this.listOfCampaignToDisplay = this.listOfCampaign;
      this.isLoading = false;

    }
  }

  serachCampaign(target: any) {
    console.log(target.value);
    let serachQuery = target.value;
    if (serachQuery != '') {
      let tempSearchList: any = [];
      this.listOfCampaignToDisplay = [];
      this.listOfCampaign.forEach((campaign: any, index: number) => {
        if (
          String(campaign['fileName'])
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase()) ||
          String(campaign['status'])
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase())
        ) {
          tempSearchList.push(campaign);
        }
      });
      this.listOfCampaignToDisplay = [];
      this.listOfCampaignToDisplay = tempSearchList;
    } else {
      this.listOfCampaignToDisplay = this.listOfCampaign;
    }
  }
  gotoAddCampaign() {
    this.router.navigate(['/catalog/campaign/add-edit-campaign']);
  }
  editCampaign(campaign: any) {
    this.appService.campaignEdit = campaign;
    this.router.navigate(['/catalog/campaign/add-edit-campaign']);

  }
  viewCampaign(campaign: any) {
    this.appService.campaignDetailToView = campaign;
    this.router.navigate(['/catalog/campaign/campaign-statistic']);

  }
  pageChanged(event: any) {
    this.p = event;
    console.log(event);
  }
  getOnlyTime(time: any) {
    let times = String(time).split('.');
    if (times.length == 1) {
      times.push('0');
    }
    return new Date(new Date(new Date().setHours(parseInt(times[0]), parseInt(String(times[1]).length > 1 ? times[1] : times[1] + '0'), 0, 0)).toISOString());
  }
  getDate(campaignDateTime: any) {
    return new Date(campaignDateTime).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
  }
  changeCampaignStatus(campaign: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      campaign: campaign,
    };
    dialogConfig.maxHeight = `95vh`;
    let dialogRef = this.matDialog.open(
      ChangeCampaignStatusComponent,
      dialogConfig
    );
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      console.log(res);
      if (res == null) {
        return;
      } else if (res['error'] != null || res['error'] != undefined) {
        return;
      } else {
        let param = { campaignId: campaign['_id'], status: res['value'] };
        try {
          let URL = `${webApi.domain + webApi.endPoint.changeCampaignStatus}`;
          const httpHeaders = new HttpHeaders({
            Authorization: `Bearer ${this.userDetail['accessToken']}`,
          });
          await this.appService.postMethodWithToken(param, URL, httpHeaders).then((data: any) => {
            if (data['success']) {
              this.listOfCampaign.forEach((camp: any) => {
                if (camp['_id'] == campaign['_id']) {
                  camp['status'] = res['value'];
                }
              });
              this.showSuccessToaster('Status Changed Successfully.', 'Success');

            } else {
              this.showWarningToaster('Unable to change status.Please try again.', 'Warning');
            }
          });
        } catch (error) {
          this.showWarningToaster('Unable to change status.Please try again.', 'Warning');
        }
      }
    });
  }
  getIsEditable(campaign: any) {
    if (campaign['status'] == 'Completed') { return false; } else { return true; }
    // if (campaign['type'] == 'One-Time-Immediate') {
    //   return true;
    // } else if (campaign['type'] == 'One-Time-Schedule') {
    //   if (new Date().getTime() < new Date(campaign['campaignDateTime']).getTime()) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // } else {
    //   return false;
    // }
  }
  showWarningToaster(message: string | undefined, title: string | undefined) {
    this.toastr.warning(message, title);
  }
  showSuccessToaster(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title);
  }
  showErrorToaster(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title);
  }
}
